import { useUnit } from 'effector-react';
import { CSSProperties, Fragment } from 'react';
import {
	GAME_FIELD_COLUMNS,
	GAME_FIELD_COUNT_CELLS,
	GAME_FIELD_ROWS,
	GameCell,
} from 'entities/game';
import { fairnessModalModel } from '../../model';
import cls from './fairness-modal-mines.module.scss';

export const FairnessModalMines = () => {
	const cells = useUnit(fairnessModalModel.$cells);

	return (
		<div
			className={cls.fairnessModalMines}
			style={
				{
					'--count-rows': GAME_FIELD_ROWS,
					'--count-columns': GAME_FIELD_COLUMNS + 1,
				} as CSSProperties
			}
			id='game-field'
		>
			{cells.map((row) =>
				row.map((cell, index) => {
					const columnIndex = index % GAME_FIELD_COLUMNS;
					const rowIndex = Math.floor((GAME_FIELD_COUNT_CELLS - 1 - index) / GAME_FIELD_COLUMNS);

					return (
						<Fragment key={`${rowIndex}${columnIndex}`}>
							<GameCell
								data-static
								variant={cell}
								className={cls.fairnessModalMinesCell}
							/>
						</Fragment>
					);
				}),
			)}
		</div>
	);
};
